<div class="container">
  @if (componentTypeOption?.requiresShopifyDeliveryOptionsFunction && !checkoutSettings?.enableDeliveryCustomization) {
    <pdq-banner [closable]="false" bannerTitle="Reminder" variant="attention">
      <li>
        • For this extension to work, please enable the Connect delivery customization function in
        <pdq-link (onClick)="redirectToSettings()" label="Settings"></pdq-link>
      </li>
    </pdq-banner>
  }
  @if (showMetrics) {
    <checkout-metrics [type]="type" #metricsComponent></checkout-metrics>
  }
</div>
<ng-template pdqHeaderContent>
  <div class="header__actions">
    @if (type !== ComponentType.LIST) {
      <pdq-button variant="tertiary" (onClick)="onCancel.next(true)">Cancel</pdq-button>
    }
    @if (type !== ComponentType.LIST) {
      <pdq-button
        variant="primary"
        [disabled]="
          saveDisabled ||
          (componentTypeOption?.requiresShopifyDeliveryOptionsFunction &&
            !checkoutSettings?.enableDeliveryCustomization)
        "
        [loading]="loading$ | async"
        (onClick)="onSave.next(true)"
        >Save</pdq-button
      >
    }
    @if (type === ComponentType.LIST) {
      <pdq-button
        pdqPopover
        [disabled]="loadingExtension"
        [popoverTemplate]="componentsType"
        [forcePosition]="'bottom'"
        [closeOnPopoverClick]
        [closeOnClickOutside]="true"
        variant="primary"
        >Add Extension</pdq-button
      >

      <ng-template #componentsType>
        <!--      // TODO change this disabled issue with response for requirements from backend on each type.service instead checking types-->
        <pdq-popover-container [loading]="false" [actionList]="true">
          <div class="action-list">
            @for (type of extComponentTypesOptions(); track type) {
              <pdq-option
                [class.option--locked]="type.locked"
                (click)="type.locked && onLockedTypeClick()"
                (onSelect)="onComponentTypeSelect(type.value)"
                [disabled]="type.disabled"
                [locked]="type.locked">
                <div class="option-title" [class.option-title--as-is]="type.value === ComponentType.ORDER_PROTECTION">
                  {{ type.label }}
                  @if (type.locked) {
                    <pdq-icon icon="lock" size="smaller" class="option-lock"></pdq-icon>
                  }
                </div>
                @if (type?.description) {
                  <div class="option-description">
                    {{ type.description }}
                  </div>
                }
              </pdq-option>
            }
          </div></pdq-popover-container
        >
      </ng-template>
    }
  </div></ng-template
>
